import trainStops from "../../../../../pages/inventory/docs/train-stops.png";
import nestingTree from "../../../../../pages/inventory/docs/nesting-tree.png";
import reservationStatusChange from "../../../../../pages/inventory/docs/reservation-status-change.png";
import * as React from 'react';
export default {
  trainStops,
  nestingTree,
  reservationStatusChange,
  React
};